module.exports = __webpack_public_path__ + "img/circle-b.cd1cb41c.png";